export default __webpack_public_path__ + "static/media/solutions.98dd88ec.jpeg";